import { render, staticRenderFns } from "./AccountColorField.vue?vue&type=template&id=61d42dde&"
import script from "./AccountColorField.vue?vue&type=script&lang=js&"
export * from "./AccountColorField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/projects/releases/338/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61d42dde')) {
      api.createRecord('61d42dde', component.options)
    } else {
      api.reload('61d42dde', component.options)
    }
    module.hot.accept("./AccountColorField.vue?vue&type=template&id=61d42dde&", function () {
      api.rerender('61d42dde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/pages/accounts/fields/AccountColorField.vue"
export default component.exports